/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used in labels.
 */
export const INSTANCE_MANAGEMENT_STRINGS = {
  advancedForms: `Advanced forms`,
  blueprintCli: `Blueprint CLI`,
  blueprintMarketplace: `Blueprint marketplace`,
  blueprints: `Blueprints`,
  blueprintsEmpty: `There are no blueprints to list.`,
  contactCustomerSuccess: `Have a system that's not shown here? Contact customer success to activate it.`,
  contentManagement: `Content Management`,
  dataServices: `Data services`,
  datastoreCliMessage: `New DXP-Next CLI is available`,
  datastoreCliPrompt: `Find out more`,
  datastoreGuide: `Quick start guide`,
  dedicated: `Dedicated`,
  featuresAndCapabilities: `Features and capabilities`,
  hostedIn: `hosted in`,
  insights: `Insights`,
  integrations: `Integrations`,
  matrixCms: `Matrix CMS`,
  matrixInstances: `Matrix instances`,
  noInstances: `There are no instances to display.`,
  saasAbbr: `SaaS`,
  saasDescription: `Software as a Service`,
  search: `Search`,
  searchInstances: `Search instances`,
  userTutorials: `User tutorials`,
};
